import React from "react";

export const LeadAutoItemContext = React.createContext();
